"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    // separators
    TokenType[TokenType["RoundBracketLeft"] = 0] = "RoundBracketLeft";
    TokenType[TokenType["RoundBracketRight"] = 1] = "RoundBracketRight";
    TokenType[TokenType["SquareBracketLeft"] = 2] = "SquareBracketLeft";
    TokenType[TokenType["SquareBracketRight"] = 3] = "SquareBracketRight";
    TokenType[TokenType["Comma"] = 4] = "Comma";
    // comparison operators
    TokenType[TokenType["Equal"] = 5] = "Equal";
    TokenType[TokenType["NotEqual"] = 6] = "NotEqual";
    TokenType[TokenType["LessThanOrEqual"] = 7] = "LessThanOrEqual";
    TokenType[TokenType["LessThan"] = 8] = "LessThan";
    TokenType[TokenType["GreaterThanOrEqual"] = 9] = "GreaterThanOrEqual";
    TokenType[TokenType["GreaterThan"] = 10] = "GreaterThan";
    TokenType[TokenType["Match"] = 11] = "Match";
    TokenType[TokenType["NotMatch"] = 12] = "NotMatch";
    TokenType[TokenType["Subset"] = 13] = "Subset";
    TokenType[TokenType["NotSubset"] = 14] = "NotSubset";
    TokenType[TokenType["Superset"] = 15] = "Superset";
    TokenType[TokenType["NotSuperset"] = 16] = "NotSuperset";
    // logical operators
    TokenType[TokenType["And"] = 17] = "And";
    TokenType[TokenType["Or"] = 18] = "Or";
    TokenType[TokenType["Not"] = 19] = "Not";
    // type literals
    TokenType[TokenType["String"] = 20] = "String";
    TokenType[TokenType["RegExp"] = 21] = "RegExp";
    TokenType[TokenType["Number"] = 22] = "Number";
    TokenType[TokenType["Boolean"] = 23] = "Boolean";
    TokenType[TokenType["Date"] = 24] = "Date";
    TokenType[TokenType["Uuid"] = 25] = "Uuid";
    // singletons
    TokenType[TokenType["Null"] = 26] = "Null";
    TokenType[TokenType["Identifier"] = 27] = "Identifier";
    TokenType[TokenType["Eof"] = 28] = "Eof";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
//# sourceMappingURL=token-type.js.map